import { createSelector } from '@reduxjs/toolkit';
import { ERepair } from '../../../../packages/api-models/common/json_query';
import { selectRepair } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Без ремонта', value: ERepair.Without },
  { label: 'Косметический', value: ERepair.Cosmetic },
  { label: 'Евроремонт', value: ERepair.Euro },
  { label: 'Дизайнерский', value: ERepair.Design },
];

export const selectRepairFilter = createSelector(selectRepair, value => ({
  label: 'Ремонт',
  value: value?.length ? (value as ERepair[]) : [null],
  options: OPTIONS,
  id: 'repair',
}));
